import { render, staticRenderFns } from "./pourquoi-utiliser-la-video-dans-votre-communication-dentreprise.vue?vue&type=template&id=9442ccfc&"
import script from "./pourquoi-utiliser-la-video-dans-votre-communication-dentreprise.vue?vue&type=script&lang=js&"
export * from "./pourquoi-utiliser-la-video-dans-votre-communication-dentreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports